import React from "react";

const FooterDashBoard = () => {
  return (
    <div>
      <footer className="boxcar-footer footer-style-one v2">
        {/*  Footer Bottom */}
        <div className="footer-bottom">
          <div className="inner-container">
            <div className="copyright-text wow fadeInUp">
              2024 Boxcars.com. All rights reserved.
            </div>
            <ul className="footer-nav wow fadeInUp" data-wow-delay="200ms">
              <li>
                <a href="#" >
                  Terms &amp; Conditions
                </a>
              </li>
              <li>
                <a href="#">Privacy Notice</a>
              </li>
            </ul>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default FooterDashBoard;
